module.exports = __webpack_public_path__ + "static/media/android.31309857.png";